import ModuleConfig from './Config';

const actions = ModuleConfig.Actions;

const initialState = {
    data: [],
    count: 0,
    page: 1,
    pageCount: 1,
    pageSize: 20,
    search: "",
    searchColumn: "",
    sortDirection: "",
    current: {},
    employees: [],
    errors: {}
}

export default function shops(state = initialState, action) {
    switch (action.type) {
        case actions.getAll.success.id:
            return Object.assign({}, state, {
                data: action.options.data,
                count: action.options.count,
                pageSize: action.options.pageSize,
                page: action.options.page,
                pageCount: action.options.pageCount,
                search: action.options.search,
                sortColumn: action.options.sortColumn,
                sortDirection: action.options.sortDirection
            })
        case actions.getOne.success.id:
        case actions.edit.success.id:
            return Object.assign({}, state, {
                current: action.options,
                errors: {}
            })
        case actions.getEmployees.success.id:
            return Object.assign({}, state, {
                employees: action.options
            })
        case actions.addEmployee.success.id:
            return Object.assign({}, state, {
                employees: [...state.employees, action.options],
                errors: {}
            })
        case actions.updateEmployee.success.id:
            return Object.assign({}, state, {
                employees: state.employees.map(emp => 
                    emp.id === action.options.id ? action.options : emp
                ),
                errors: {}
            })
        case actions.removeEmployee.success.id:
            return Object.assign({}, state, {
                employees: state.employees.filter(emp => emp.id !== action.options.id)
            })
        case actions.edit.failure.id:
        case actions.create.failure.id:
        case actions.addEmployee.failure.id:
        case actions.updateEmployee.failure.id:
            return Object.assign({}, state, {
                errors: action.options
            })
        case actions.delete.success.id:
            return Object.assign({}, state, {
                current: {},
                errors: {}
            })
        default:
            return state;
    }
}
